module.exports = __webpack_public_path__ + "background12.jpg?65a46586adb078f858eb2cf3d151b02d";